import * as toastr from "toastr";
import { ICAMSKey, IAPIResult, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Entity_RouteChangeRouteCodes {

    // ----------------------------------------------------------- //
    // GLOBAL VARS

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openRouteChangeRouteCodePanel = (routeCode: string, callback: Function): void => {
        const self = this;
       
        // Open the edit modal
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Route/RouteChangeRouteCodeView', { routeCode: routeCode }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            Utilities.UnBlockUI();

            // Show the form
            Utilities.GetModal('#routeChangeRouteCodeModal', ModalAction.Create);
            
            // Get form validation
            Utilities.InitFormValidation($("#routeChangeRouteCodeForm"));

            $('#routeChangeRouteCodeSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
           
                // Validate
                let form: any = $('#routeChangeRouteCodeForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();
                let formData = new FormData(<any>$('#routeChangeRouteCodeForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Route/ChangeRouteCode',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Code change!');
                                Utilities.GetModal('#routeChangeRouteCodeModal', ModalAction.Hide);
                                callback(result.data);
                            }
                            else {
                                if (result.message != null) toastr.error(result.message);
                                else toastr.error('Failed to change code!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI();
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });
            
            $('#routeChangeRouteCodeCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#routeChangeRouteCodeModal', ModalAction.Hide);
                callback(null);
            });

            $('#routeChangeRouteCodeCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#routeChangeRouteCodeModal', ModalAction.Hide);
                callback(null);
            });

        });
    }
}




